import React from 'react';
import { useForm, type SubmitHandler } from 'react-hook-form';
import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { toast } from '@/components';
import { Form } from '@/components/form/form';
import { FormInputWrapper } from '@/components/form/form-input-wrapper';
import { usePutUsersChangePassword, type UsersChangePasswordRequest } from '@/services/users';
import { useAuthStore } from '@/stores';
import { changePasswordSchema } from './changePasswordSchema';

type ChangePasswordProps = {
  opened: boolean;
  onClose?: () => void;
};

const ChangePassword = ({ opened, onClose }: ChangePasswordProps) => {
  const { logout } = useAuthStore.getState();
  const form = useForm<UsersChangePasswordRequest>({
    defaultValues: {
      new_password: '',
      new_password_confirmation: '',
      old_password: '',
    },
  });

  const { mutateAsync, isPending } = usePutUsersChangePassword();

  const onSubmit: SubmitHandler<UsersChangePasswordRequest> = async (payload) =>
    mutateAsync(payload)
      .then(() => {
        toast.success({
          title: 'Berhasil',
          message: 'Harap Login Kembali',
        });
        logout();
      })
      .catch((e) => {
        toast.error({
          title: 'Gagal',
          message: e?.response?.data?.message ?? 'Mengubah Password!',
        });
      });

  return (
    <Modal
      w={560}
      opened={opened}
      onClose={() => onClose?.()}
      centered
      title={
        <Stack gap={0}>
          <Text fz={36}>Ganti Kata Sandi</Text>
          <Text c="gray">Ganti kata sandi lama anda disini</Text>
        </Stack>
      }
    >
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          {changePasswordSchema.map((props) => (
            <FormInputWrapper key={props.name} {...props} />
          ))}
          <Group align="end" mt={16}>
            <Button size="xs" ml="auto" loading={isPending} type="submit">
              Submit
            </Button>
          </Group>
        </form>
      </Form>
    </Modal>
  );
};

export default ChangePassword;
